<template>
  <div>
    <div class="form-group row">
      <div class="col-md-12">
        <el-input type="search" name="search" placeholder="Search Form Field Blocks" clearable v-model="searchQuery" />
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4" style="display: flex" v-for="formFieldBlock in queriedData">
        <card
          type="pricing"
          class="card-plain"
          style="flex-basis: 100%; display: flex; flex-direction: column; justify-content: space-between;"
        >
          <div>
            <h6 slot="header" style="margin-bottom: 0"> {{ formFieldBlock.name }}</h6>
            <h5 style="margin-bottom: 0; margin-top: 6px;">Fields</h5>
            <ul style="margin-top: 0; margin-bottom: 3px;">
              <li v-for="formFieldMeta in formFieldBlock.formFields">{{ formFieldLabel(formFieldMeta.formFieldId) }}</li>
            </ul>
          </div>
          <button class="btn btn-fill btn-info" style="align-self: center;" @click="edit(formFieldBlock)">
            Edit
          </button>
          <button class="btn btn-fill btn-danger" style="align-self: center;" @click="confirmDelete(formFieldBlock)">
            Delete
          </button>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import {Card} from 'src/components/UIComponents'
import {mapGetters} from 'vuex'
import {OK, NO_CONTENT} from 'http-status-codes'
import {notifySuccess, notifyError} from 'src/utilities/utils'

export default {
  components: {
    Card
  },
  computed: {
    ...mapGetters({
      tableData: 'inspectorApp/formFieldBlocks/results'
    }),
    queriedData() {
      if (!this.searchQuery) {
        return this.tableData
      }
      const foundBlocks = []

      for (const block of this.tableData) {
        let value = block.name.toString().toLowerCase()
        if (value.includes(this.searchQuery.toLowerCase().trim())) {
          foundBlocks.push(block)
        }
      }

      return foundBlocks
    }
  },
  data() {
    return {
      minCardHeight: 150,
      minCardRowHeight: [],
      searchQuery: ''
    }
  },
  methods: {
    edit(formFieldBlock) {
      this.$eventHub.$emit('show-modal-1', 'Form Field Block', formFieldBlock, '600px')
    },
    async confirmDelete(formFieldBlock) {
      let showButton = false
      this.toDelete = formFieldBlock.id

      const responseTaskNames = await this.$store.dispatch('tasks/names/fetchByFormFieldBlockId', formFieldBlock.id)
      if (OK !== responseTaskNames.status) {
        notifyError(this, 'Failed to fetch Task Names associated with this form field block. Unable to safely delete Form Field Block.')
        return
      }

      if (responseTaskNames.data.length > 0) {
        let message = 'You can not delete <strong>' + formFieldBlock.name + '</strong> as it is referenced by the following task names.'
        const taskNames = responseTaskNames.data
        message += '<p><ul>'
        taskNames.forEach((taskNames) => {
          message += '<li>' + taskNames.name + '</li>'
        })
        message += '</ul></p>'
        message += '<p>If you really want to delete this Field Form Block, you must first remove associations to it in each of the task names listed above, then come back here and delete the Field Form Block.</p>'
        showButton = false

        this.showConfirmDelete(formFieldBlock, message, showButton)
        return
      }

      const message = 'Are you sure you want to delete <strong>' + formFieldBlock.name + '</strong>? This will completely remove the form field block.'

      // happy path - form field block can be deleted
      showButton = true
      this.showConfirmDelete(formFieldBlock, message, showButton)
    },
    showConfirmDelete(formFieldBlock, message, showButton) {
      const payload = {
        message,
        entity: formFieldBlock,
        delete: this.delete,
        showButton
      }
      this.$eventHub.$emit('show-modal-1', 'Confirm Delete', payload, '600px')
    },
    async delete() {
      const response = await this.$store.dispatch('delete', {
        id: this.toDelete,
        endpoint: 'form-field-blocks'
      })
      if (NO_CONTENT === response.status) {
        this.$store.commit('inspectorApp/formFieldBlocks/delete', this.toDelete)
        notifySuccess(this, 'Form Field Block Deleted Successfully')
      } else {
        notifyError(this, response.message)
      }
    },
    formFieldLabel(id) {
      const formField = this.$store.get('inspectorApp/formFields/byId', id)

      if (formField) {
        return formField.label
      }

      return ''
    }
  },
  async mounted() {
    await this.$store.dispatch('inspectorApp/formFieldBlocks/fetchAll')
  }
}
</script>

<style scoped>

</style>
